module.exports = __webpack_public_path__ + "static/assets/0ebf20ddd742d0b1c9733df9e91a25b0.svg";